export type ApiMakeObject = {
  default_label: string;
  labels?: Array<{
    /**
     * Label text
     */
    label: string;
    /**
     * Label text
     */
    label_short?: string;
    /**
     * Language code
     */
    language: string;
  }>;
  make: string;
  vehicle_type: string;
};
